/**
 * Greek typography helpers.
 *
 * Greek capital letters with tonos (Ά Έ Ή Ί Ό Ύ Ώ) look bad in all-caps
 * contexts. Use elUpperCase() wherever text is displayed in uppercase.
 */

/** Strip all combining diacritical marks (works for Greek tonos, Latin accents, etc.). */
export const stripTonos = (str) =>
    str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : str;

/** Uppercase a string and strip tonos — use instead of CSS text-transform:uppercase for Greek. */
export const elUpperCase = (str) =>
    str ? stripTonos(String(str).toUpperCase()) : str;
